export default __webpack_public_path__ + "c9158658b8ffc3a9f4b735e63eec5d3c.png";